<script>
export default {
  props: {
    componentData: {
      default: [],
    },
  },
  data() {
    return {
      isToggled: false,
    }
  },
}
</script>

<template>
  <div>
    <b-card-header header-tag="header" class="header" role="tab">
      <b-button @click="arrowToggle()" block v-b-toggle.accordion-15 class="w-100 button">
        <div class="inlineButton">
          <div class="buttonTitle">
            {{ componentData.title }}
          </div>
          <div>
            <i :class="{ down: isToggled, up: !isToggled }"> </i>
          </div>
        </div>
      </b-button>
    </b-card-header>
    <b-collapse id="accordion-15" visible accordion="my-accordion15" role="tabpanel">
      <b-card-body>
        <div class="desc" :style="componentData.rtl ? 'direction: rtl; text-align: right;' : ''">
          {{ componentData.feedback }}
        </div>
      </b-card-body>
    </b-collapse>
  </div>
</template>

<style scoped lang="scss">
.header {
  padding: 0;
  border: none;
  background: #f0f1f1;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
  border-radius: 5px;
  width: 100%;
}
.button {
  padding: 11px 20px;
  box-shadow: none;
  border: none;
  background: #f0f1f1;
}
.borderRdius {
  border-radius: 7px;
}
::v-deep .collapsed {
  outline: none;
  border: none;
  background: #fafafa;
}
.buttonTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.collapse {
  border: 1px solid #f0f1f1;
  border-radius: 5px;
}
.inlineButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
i {
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
.desc {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: #555555;
  direction: ltr;
  text-align: left;
}
</style>
